import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {CheckboxFormFieldComponent} from '@aviary/forms/fields/checkbox-form-field/checkbox-form-field.component';
import {ExtendedFormGroup} from '@aviary/forms/extensions/extended-form-group/extended-form-group';
import {MatIcon} from '@angular/material/icon';
import {getExtendedControlFrom} from '@aviary/forms/form.helpers';
import {ExtendedFormControl} from '@aviary/forms/extensions/extended-form-control/extended-form-control';
import {LinkButtonComponent} from '@aviary/buttons/link-button/link-button.component';

@Component({
  selector: 'px-sms-terms-checkbox',
  template: `
    @let cbxDisabled = checkboxControl.disabled;
    <mx-checkbox-form-field [fieldName]="fieldName" [formGroup]="formGroup" overrideLabel="" class="mx-checkbox-align-start">
      <div class="flex-col gap-1">
        <p class="text-body-medium">
          I agree to receive automated SMS/text notifications from my library related to my library account and circulation activity. Message frequency varies.
          Message and data rates may apply. I can manage notification preferences in my account or contact library staff for help. See
          <mx-link-button label="SMS Notification Terms" linkType="inline" href="https://www.simplicity-ils.com/sms-notification-terms"
                          [enabled]="!cbxDisabled"/>
          and
          <mx-link-button label="Privacy Policy" linkType="inline" href="https://www.simplicity-ils.com/privacy-policy" [enabled]="!cbxDisabled"/>
          <span>.</span>  <!-- The span prevents an extra space between the link and the period. -->
        </p>
        @if (!isTermsAcceptedValid) {
          <div class="flex flex-row gap-x-[0.161rem] w-full items-start text-label-small text-error">
            <mat-icon class="mat-icon-size-3.5 material-icons-outlined shrink-0">warning</mat-icon>
            <p>SMS consent is required to use SMS notifications. Check the box above to confirm consent, or select a different notification method.</p>
          </div>
        }
      </div>
    </mx-checkbox-form-field>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CheckboxFormFieldComponent, MatIcon, LinkButtonComponent]
})
export class SmsTermsCheckboxComponent implements OnInit {
  @Input() public formGroup: ExtendedFormGroup;
  @Input() public fieldName: string = 'smsTermsAccepted';
  @Input() public isTermsAcceptedValid: boolean;
  public checkboxControl: ExtendedFormControl<boolean>;

  ngOnInit(): void {
    this.checkboxControl = getExtendedControlFrom(this.formGroup, this.fieldName);
  }
}
